import { useMyAvatarUrlSizesQuery } from '../gen/user'
import type { MyAvatarUrlSizesQuery } from '../gen/user'

function selectProfile(data: MyAvatarUrlSizesQuery) {
  return data.getMyAccountUserProfile.profile
}

/**
 * Picks the smallest size the backend lists that is at least twice `displaySize`. The sizes are only
 * used once they describe `avatarUrl`, which lags right after an upload. Default avatars list none.
 */
export function useMyAvatarUrl(avatarUrl: string | null | undefined, displaySize: number) {
  const { data: profile } = useMyAvatarUrlSizesQuery(undefined, {
    enabled: Boolean(avatarUrl),
    select: selectProfile,
  })

  if (!avatarUrl || profile?.avatarUrl !== avatarUrl) {
    return { src: avatarUrl, isUpload: false }
  }

  const sizes = profile.avatarUrlSizes
    .map(size => ({ width: Number(size.key), url: size.value }))
    .toSorted((a, b) => a.width - b.width)
  const size = sizes.find(({ width }) => width >= displaySize * 2) ?? sizes.at(-1)
  return { src: size?.url ?? avatarUrl, isUpload: sizes.length > 0 }
}
